
import { reactive} from "vue";
import DynamicFilterForm from "@/components/Shared/Dynamicform/DynamicFilterForm.vue";

export default {
  name: "WildBookFilter",
  inheritAttrs: false,
  components: {
    DynamicFilterForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "api/Form/loadForm",
      apiSaveMethod: "",
      form: "Wildbuch",
      page: "WildbuchFilter",
      remoteId: "",
      mode: "DynamicForm",
      routeName: "WildBook",
      filter: "WildBookFilter"
    });
    return {
      request
    };
  }
};
